import { PropType, defineComponent, h } from 'vue';
import { ID } from '@phi/newtype';
import { OnshapeElement } from '@phi/onshape';
import { vif1 } from '@phi/util/vuetils';
import { Option } from '@vaaas/fpts/option';
import { Unary } from '@vaaas/fpts/data';
import OnshapeElementExplorer from '../OnshapeElementExplorer';
import OnshapeDocumentExplorer from '../OnshapeDocumentExplorer';

export default defineComponent({
    props: {
        document: {
            required: false,
            type: null as any as PropType<ID<'document'>>,
        },

        workspace: {
            required: false,
            type: null as any as PropType<ID<'workspace'>>,
        },

        element: {
            required: false,
            type: null as any as PropType<OnshapeElement>,
        },

        elementFilter: {
            required: false,
            type: Function as PropType<Unary<OnshapeElement, boolean>>,
            default: () => true,
        },

        can_select_document: {
            required: false,
            type: Boolean,
            default: true,
        },

        sub_heading: {
            required: false,
            type: Boolean,
            default: true,
        },

        placeholder: {
            required: false,
            type: String,
            default: 'Search by file name'
        },
    },

    computed: {
        has_selected_document() {
            return Boolean(this.document && this.workspace);
        }
    },

    emits: {
        'update:workspace': (x: Option<ID<'workspace'>>) => true,
        'update:document': (x: Option<ID<'document'>>) => true,
        'update:element': (x: Option<OnshapeElement>) => true,
    },

    render() {
        return h('div', {
            class: {
                'select-document-element': true,
                'selecting-document': !this.has_selected_document,
                'selecting-element': this.has_selected_document,
            },
        }, [
            vif1(this.has_selected_document)(() => h(OnshapeElementExplorer, {
                document: this.document,
                workspace: this.workspace,
                element: this.element,
                'onUpdate:element': (x) => this.$emit('update:element', x),
                'onBack': () => {
                    this.$emit('update:document', undefined);
                    this.$emit('update:workspace', undefined);
                },
                elementFilter: this.elementFilter,
                back: this.can_select_document,
                sub_heading: this.sub_heading,
                placeholder: this.placeholder,
                hidden_toggle: false,
            })),
            vif1(!this.has_selected_document && this.can_select_document)(() => h(OnshapeDocumentExplorer, {
                document: this.document,
                workspace: this.workspace,
                'onUpdate:document': x => this.$emit('update:document', x),
                'onUpdate:workspace': x => this.$emit('update:workspace', x),
            })),
        ]);
    },
});
